import React from "react";
import type { User } from "../api/useUser";
import { useUser } from "../api/useUser";
import type { Permission } from "diagnostics-domain/Permissions";
import type { UserRole } from "../api/useUsers";
import {
  canUserDo,
  canUserDoOnProject,
  canUserDoOnSomeProject,
} from "diagnostics-domain/canUserDo";
export function useHasUserRole(user: User, role: UserRole) {
  if (user.roles.global === role) return true;
  return false;
}

export function useCanUserDo(permission: Permission) {
  const user = useUser();
  return React.useMemo(() => canUserDo(user, permission), [permission, user]);
}

export function useCanUserDoOnProject(permission: Permission, projectId: string) {
  const user = useUser();
  return React.useMemo(
    () => canUserDoOnProject(user, permission, projectId),
    [permission, projectId, user],
  );
}

export function useCanUserDoOnSomeProject(permission: Permission) {
  const user = useUser();
  return React.useMemo(() => canUserDoOnSomeProject(user, permission), [permission, user]);
}
